import React, { useEffect, useState } from "react";
import Print_DesignCaller from "./Print_DesignCaller";
import { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import { useDispatch, useSelector } from "react-redux";
import { View_ScreenName } from "./Utility";
import { ShowHide_Popup } from "../features/Transactionstates";
function WhatsApp(props) {
  const dispatch = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  // Transaction.js renders <WhatsApp /> with NO props, so the voucher / screen
  // come from the store (same source TransactionView uses)
  const _Common = useSelector((state) => state.Transstates?.Common);
  const _HT = useSelector((state) => state.Transstates?.Header);
  const iScrId = props.iScrId ?? props.ScrId ?? _Common?.iScrId;
  const iVouchId =
    props.iVouchId || _HT?.SelectedVouchId || _HT?.iVouchId || 0;

  const [PhoneNumber, setPhoneNumber] = useState("");
  const [numberEmptyError, setnumberEmptyError] = useState("");
  const [strMessage, setstrMessage] = useState("");
  const [strScrName, setstrScrName] = useState("");
  const [EntData, setsetEntData] = useState();

  useEffect(() => {
    Load_Voucher();
  }, []);

  // props.Close is never passed, so the close icon did nothing.
  // ShowHide_Popup closes every other popup, so opening this one closed the
  // View list. Closing goes back to the View list (IsTransView) so the user
  // can continue with the next voucher
  const Popup_Close = () => {
    if (props.Close) props.Close();
    else dispatch(ShowHide_Popup("IsTransView"));
  };

  // "Mobile No : 98765 43210" / "+91 9876543210" / "09876543210" -> 10 digits
  const CleanMobile = (strValue) => {
    let digits = String(strValue || "")
      .replace(/^\s*mobile\s*no\s*:\s*/i, "")
      .replace(/\D/g, "")
      .replace(/^0+/, "");
    if (digits.length > 10 && digits.startsWith("91")) digits = digits.slice(2);
    return digits.slice(0, 10);
  };

  const Load_Voucher = async () => {
    if (!iVouchId) {
      Show_Message(dispatch, "Please Select Voucher", "info");
      Popup_Close();
      return;
    }
    Pre_Loading(dispatch, true);
    try {
      // Same path the Print / PDF buttons use (PrintDesing/Print_Data/...).
      // The old code called PrintDesing/PrintPreView/... which is a different
      // endpoint with a different parameter order
      const objEntPdf = await Print_DesignCaller(
        _AuthParems,
        iScrId,
        "Transaction",
        iVouchId,
        0,
        "PDF",
        dispatch,
        true
      );
      if (!objEntPdf || !objEntPdf.PartyInfo || !objEntPdf.PartyInfo[0]) {
        Show_Message(dispatch, "Unable to prepare the invoice details", "info");
        Popup_Close();
        return;
      }
      const name = props.ScrName || (await View_ScreenName(iScrId));
      setstrScrName(name || "Invoice");
      setPhoneNumber(CleanMobile(objEntPdf.PartyInfo[0].mobile1));
      setsetEntData(objEntPdf);
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    } finally {
      Pre_Loading(dispatch, false);
    }
  };

  // PrintInvoice sets FileName = voucher no for every screen (VoucherName)
  const VoucherNo = (Info) =>
    Info.FileName && Info.FileName !== "Invoice"
      ? Info.FileName
      : Info.PartyInfo[0].salInvNo || "";

  const BuildMessage = (Info) => {
    const partyinfo = Info.PartyInfo[0];
    const Summary = (Info.Summary && Info.Summary[0]) || {};
    const strCompanyName = _AuthParems.Branchname;
    const strNo = VoucherNo(Info);
    // Info.mobile does not exist in the print data, it printed "undefined"
    const strContact = Info.mobile ? ` at ${Info.mobile}` : "";
    // the Notes field was never added to the message
    const strNote =
      strMessage.trim() !== "" ? `\n${strMessage.trim()}\n` : "";
    const strDate = partyinfo.salInvDate || partyinfo.salRetDate || "";
    const strDateLine = strDate
      ? `Date: ${strDate}\n`
      : "";

    if (strScrName === "Sales Invoice") {
      return `
Dear ${partyinfo.custName || "Customer"},
Thank You for Your Recent Purchase Invoice-#${strNo}

We hope this message finds you well. We want to express our sincere gratitude for choosing ${strCompanyName} for your recent purchase. We appreciate your trust in our Products.

Your order details are as follows:

Invoice Number: ${strNo}
Date of Purchase: ${partyinfo.salInvDate}
Total Amount: ₹${stringtodecimal(Summary.netAmt)}
${strNote}
We understand that you have a choice when it comes to your Product needs, and we are thrilled to have had the opportunity to serve you. Our team is committed to providing top-notch quality and excellent customer service, and we hope your recent experience reflects that commitment.

If you have any questions about your purchase or if there's anything else we can assist you with, please don't hesitate to reach out to our customer support team${strContact}.

Once again, thank you for choosing ${strCompanyName}. We truly value your business and look forward to serving you again in the future.

Best Regards,
${strCompanyName}`;
    }
    // Quotation / Order / Challan / Purchase / Return ... screens
    return `
Dear ${partyinfo.custName || "Sir / Madam"},

Please find ${strScrName} #${strNo} from ${strCompanyName}.

${strDateLine}Total Amount: ₹${stringtodecimal(Summary.netAmt)}
${strNote}
If you have any questions, please don't hesitate to contact us${strContact}.

Best Regards,
${strCompanyName}`;
  };

  const ShowNumberError = (strText) => {
    setnumberEmptyError(strText);
    setTimeout(() => setnumberEmptyError(""), 3000);
  };

  const Sent_WhatsappMsg = async () => {
    var Info = EntData;
    if (!Info) {
      Show_Message(dispatch, "Voucher details are not loaded", "info");
    } else if (PhoneNumber.length < 1) {
      ShowNumberError("Mobile number cannot be empty!");
    } else if (!/^[6-9]\d{9}$/.test(PhoneNumber)) {
      ShowNumberError("Please enter a valid 10 digit mobile number");
    } else {
      // Removed: source=<whole PDF base64>. WhatsApp ignores it (the file was
      // never attached) and a multi-MB URL can break the browser
      // wa.me opens the WhatsApp desktop app or WhatsApp Web (and the app on
      // mobile). web.whatsapp.com/send forced WhatsApp Web only.
      // Template indent spaces are removed from every line of the message.
      try {
        const url = `https://wa.me/91${PhoneNumber}?text=${encodeURIComponent(
          BuildMessage(Info).replace(/^[ \t]+/gm, "").trim()
        )}`;
        const shareWindow = window.open(url, "_blank");
        if (!shareWindow) {
          Show_Message(dispatch, "Allow pop-ups to open WhatsApp", "info");
          return;
        }
        shareWindow.opener = null;
      } catch (err) {
        console.error("WhatsApp share could not be opened", err);
        Show_Message(dispatch, err?.message || "Unable to open WhatsApp", "error");
      }
    }
  };
  const stringtodecimal = (num) => {
    const n = Number(num);
    return (Number.isFinite(n) ? n : 0).toFixed(2);
  };
  // Clear Message was an empty function
  const Clear_Message = () => {
    setstrMessage("");
  };

  return (
    <div className="popup-container">
      <div className="popup-content">
        <div className="popup-header">
          <h5>Sent WhatsApp</h5>
          <div className="icon-popup-btn-grp">
            <span className="icon-btn" onClick={Popup_Close}>
              <i className="fa-regular fa-rectangle-xmark"></i>
            </span>
          </div>
        </div>
        <div className="popup-body">
          <div className="row">
            {numberEmptyError !== "" && (
              <div style={{ color: "red", fontSize: "13px" }}>
                {numberEmptyError}
              </div>
            )}
            <div className="col-sm-12 col-md-12">
              <label style={{ color: "gray" }}>Phone Number</label>
              <div className="What_Phone">
                <span>+91</span>
                <input
                  className="form-control"
                  type="tel"
                  maxLength={10}
                  value={PhoneNumber}
                  placeholder="Please Enter Mobile Number"
                  onChange={(e) =>
                    setPhoneNumber(e.target.value.replace(/\D/g, "").slice(0, 10))
                  }
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-12">
              <label>Notes</label>
              <input
                className="form-control"
                type="text"
                value={strMessage}
                placeholder="Please Enter Message"
                onChange={(e) => setstrMessage(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-btn-group">
            <button
              type="button"
              className="btn-fabgreen"
              onClick={Sent_WhatsappMsg}
            >
              Sent Message
            </button>
            <button
              type="button"
              className="btn-fabgreen"
              onClick={Clear_Message}
            >
              Clear Message
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhatsApp;
